import Post from '../helpers/post';

let getJurisdictions = (state) => {
    const url = `api/Jurisdictions/Get`;
    return Post(url, {
        state
    });
};

export default getJurisdictions;